<script setup lang="ts">
import { useId } from 'vue';
import { BaseIcon } from '@magma-app/magma-lapilli';

defineProps<{ title: string; icon: string; modelValue: boolean }>();
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>();
const id = useId();
</script>

<template>
  <section>
    <h2>
      <button
        :id="`${id}-heading`"
        type="button"
        class="flex min-h-16 w-full items-center gap-3 rounded-md px-3 py-4 text-left text-mgm-txt-sm font-medium text-foreground-emphasis hover:bg-background-subtle-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-foreground-brand-default"
        :aria-expanded="modelValue"
        :aria-controls="`${id}-content`"
        @click="emit('update:modelValue', !modelValue)"
      >
        <BaseIcon :icon="icon" class="shrink-0" :size="20" />
        <span class="min-w-0 flex-1">{{ title }}</span>
        <BaseIcon
          icon="chevron-down"
          class="shrink-0 transition-transform"
          :class="{ 'rotate-180': modelValue }"
          :size="18"
        />
      </button>
    </h2>
    <div
      v-show="modelValue"
      :id="`${id}-content`"
      :aria-labelledby="`${id}-heading`"
      class="px-3 pb-5 pt-3 sm:pl-11"
    >
      <slot />
    </div>
  </section>
</template>
